"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAutocomplete = void 0;
var _react = require("react");
var _functions = require("../../../page-body/site-search-results/utils/functions");
var _searchContext = require("./search-context");
/**
 * Autocomplete callback for search functionality
 * @returns {Function} Autocomplete callback function
 */
const useAutocomplete = () => {
  const {
    autocompleteEndpoint,
    setList,
    appKeyHeader
  } = (0, _searchContext.useInternalSearch)();
  return (0, _react.useCallback)(async (keyword, callback, abortController) => {
    if (typeof window !== 'undefined') {
      const apiUrl = new URL(autocompleteEndpoint);
      apiUrl.searchParams.set('q', (0, _functions.sanitizeDomainQuery)(keyword));
      const urlString = apiUrl.href.replaceAll('%3D', '=');
      try {
        const res = await fetch(urlString, {
          method: 'GET',
          signal: abortController.signal,
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-App-Key': appKeyHeader
          }
        });
        const data = await res.json();
        if (data.length > 0) {
          setList(data);
        } else {
          setList([]);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
      if (callback) {
        return callback();
      }
    }
  }, [autocompleteEndpoint, setList]);
};
exports.useAutocomplete = useAutocomplete;